export default {"src":"/_next/static/media/x.8260031d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};